import { render } from "./Index.vue?vue&type=template&id=71bd8b68&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=71bd8b68&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bd8b68"],['__file',"src/assets/js/pages/Gate/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71bd8b68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71bd8b68', __exports__)) {
    api.reload('71bd8b68', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=71bd8b68&scoped=true", () => {
    api.rerender('71bd8b68', render)
  })

}


export default __exports__